import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const AddBold: FC<IconProps> = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8 0.5C7.30964 0.5 6.75 0.919733 6.75 1.4375V6.75H1.4375C0.919733 6.75 0.5 7.30964 0.5 8C0.5 8.69036 0.919733 9.25 1.4375 9.25H6.75V14.5625C6.75 15.0803 7.30964 15.5 8 15.5C8.69036 15.5 9.25 15.0803 9.25 14.5625V9.25H14.5625C15.0803 9.25 15.5 8.69036 15.5 8C15.5 7.30964 15.0803 6.75 14.5625 6.75H9.25V1.4375C9.25 0.919733 8.69036 0.5 8 0.5Z'
      fill={color} />
  </svg>
)

export default AddBold
